import { Disclosure, Transition } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";
import Header from "../components/header";
import { FaqResponse } from "../models/faq";
import { VideoResponse } from "../models/video";
import { FaqsService } from "../services/faqs-service";
import { VideosService } from "../services/videos-service";

export default function Instructions() {
  const [faqs, setFaqs] = useState<FaqResponse[]>([]);
  const [videos, setVideos] = useState<VideoResponse[]>([]);

  useEffect(() => {
    (async () => {
      setFaqs(await FaqsService.getAll());
      setVideos(await VideosService.getAll());
    })();
  }, []);

  return (
    <>
      <Header>
        <div className="container mx-auto w-full">
          <div className="container h-[80px] mx-auto text-3xl text-white font-semibold flex items-center">
            Instructions
          </div>
        </div>
      </Header>
      {/* NOTE: Temporarily set this page up with static content until we can revamp this page */}
      <div className='container mx-auto my-16'>
        <div className='mb-4 font-semibold'>Non-partisan/presidential elections notice:</div>
        <div>All precincts will need a minimum of TWO separate charts to properly perform a logic & accuracy test, one for Democratic and one for Republican. IF there are additional, non-partisan styles, this will require a third chart to comply with Michigan's promulgated rules.</div>
        <div className='mt-10'>If you have any additional questions or need further assistance, we're here to help. Visit our Contact Us page at <a href='/contact-us' className='text-blue-500'>https://www.ballotchart.com/contact-us</a> to get in touch.</div>
      </div>
      <div className='container mx-auto my-4'>
        <div className='mb-4 font-semibold'>Partisan Primary Chart Creation</div>
        <div>Click the link below to watch a step-by-step guide on creating a partisan primary chart.</div>
        <a className='text-blue-500 cursor-pointer' href='https://drive.google.com/file/d/1sBRGU_e7WbaJ3Qntdu-vNtbveeZXvVTG/view?ts=667c27c2'>
          Partisan Primary Chart Creation Walkthrough Video
        </a>
      </div>
      {/*<div className="container mx-auto my-16">
        <div className="flex">
          {videos.map((video, i) => (
            // TODO: videos layout
            <div key={`video-${i}`} className="aspect-video"></div>
          ))}
        </div>
        <hr className="mt-16" />
        <div className="flex flex-col gap-10 mt-10">
          {faqs.map((faq) => (
            <div key={`faq-${faq.id}`}>
              <Disclosure>
                {({ open }) => (
                  <>
                    <Disclosure.Button className="flex justify-between w-full">
                      <div className="text-lg font-semibold text-primary-blue">
                        {faq.question}
                      </div>
                      <div>
                        {open ? (
                          <MinusIcon className="h-8 text-[#DF1F26]" />
                        ) : (
                          <PlusIcon className="h-8 text-[#DF1F26]" />
                        )}
                      </div>
                    </Disclosure.Button>

                    <Transition
                      show={open}
                      enter="transition duration-100 ease-out"
                      enterFrom="transform scale-95 opacity-0"
                      enterTo="transform scale-100 opacity-100"
                      leave="transition duration-75 ease-out"
                      leaveFrom="transform scale-100 opacity-100"
                      leaveTo="transform scale-95 opacity-0"
                    >
                      <Disclosure.Panel static>
                        <div className="mt-10">{faq.answer}</div>
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
              <hr className="mt-10" />
            </div>
          ))}
        </div>
                        </div>*/}
    </>
  );
}
